import { Component, h } from 'preact'
import { ProductAreaType } from '../../product-areas/ProductAreaSelect'
import Phrase from '../../../libs/translationsUtils/phrase'
import InputGroup from '../../ui-components/InputGroup'
import qs from 'qs'

interface Props {
  productAreas: Array<ProductAreaType>,
  selectedProductArea: null | string
}

interface State {
  selectedProductArea: null | string
}

export class ProductAreaFilter extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      selectedProductArea: props.selectedProductArea === null ? null : props.selectedProductArea
    }
    this.setQueryParams = this.setQueryParams.bind(this)
    this.setSelectedIdeationStatus = this.setSelectedIdeationStatus.bind(this)
  }

  setQueryParams (newProductArea: string | null) {
    const searchQuery = window.location.search
    let queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })

    delete queryParameters?.filters?.productArea

    let newQuery = newProductArea === null ? { filters: queryParameters?.filters || {} } : { filters: { ...queryParameters?.filters || {}, productArea: [newProductArea] } }

    let combinedQuery = { ...queryParameters, ...newQuery }

    delete combinedQuery?.page

    window.history.pushState('', '', `?${qs.stringify(combinedQuery)}`)
  }

  setSelectedIdeationStatus (newProductArea: string | null) {
    this.setState({ selectedProductArea: newProductArea })
    this.setQueryParams(newProductArea)
  }

  render ({ productAreas }: Props, { selectedProductArea }: State) {
    return (
      <div className='box__content box__pad ideation-filters'>
        <h3 className='widget-title'><Phrase p='filter.by.product' /></h3>
        <ul className='ideation-filters__product-area'>
          <li className={selectedProductArea === null ? 'selected' : ''} onClick={() => this.setSelectedIdeationStatus(null)}>
            <div className='vertical-line' />
            <Phrase p='all.products' />
          </li>
          {
            productAreas.map(({ name }) => (
              <li className={selectedProductArea === name ? 'selected' : ''} onClick={() => this.setSelectedIdeationStatus(name)}>
                <div className='vertical-line' />
                <span>{ name }</span>
              </li>
            ))
          }
        </ul>
      </div>
    )
  }
}

interface PropsForConfigurator {
  title: string,
  onChange: (state: {title: string}) => void
}

interface StateForConfigurator {
  title: string
}

export class ProductAreaFilterWithHelp extends Component<PropsForConfigurator, StateForConfigurator> {
  constructor (props: PropsForConfigurator) {
    super(props)
    this.state = {
      title: props.title
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle }, () => this.props.onChange(this.state))
  }

  render (_: PropsForConfigurator, { title }: StateForConfigurator) {
    return (
      <div className=''>
        <InputGroup
          title='Title'
          name='title'
          placeholder='Add a title'
          type='text'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
          value={title} />
      </div>
    )
  }
}

export default ProductAreaFilter
